export const initialState = {
  loadingStatus: {
    logoLoading: false,
    termLoading: false,
    privacyLoading: false,
  },
  termData: '',
  privacyData: '',
};
